import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { editInscription, getInscriptionsByClub } from '../../../../actions/activities/inscriptionsActions'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import ActivitiesSubMenu from '../../../../components/menus/ActivitiesSubMenu'
import InscriptionSummary from '../../../../components/Activities/InscriptionSummary'
import useAuth from '../../../../context/auth/useAuth'
import Swal from 'sweetalert2'
import ClubBreadCrumbs from '../../../../components/breadcrumbs/ClubBreadCrumbs'
import Loader from '../../../../components/design/Loader/Loader'

export default function Inscriptions({usertype, inscriptionselected, handleInscriptionSelect}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const {inscriptions, loadinginscriptions} = useSelector(state=>state.inscriptions)
    const {club} = useSelector(state=>state.clubs)

    const [typeform, setTypeform] = useState(null)
    const translatedInscriptions = inscriptions?.map(inscription => ({
        ...inscription,
        translatedStatus: t('inscriptions.status' + inscription.status),
    }))
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(clientauth){
            dispatch(getInscriptionsByClub(club?._id))
        }
    },[dispatch, t, clientauth, club])

    const handleSelectChange = (inscription, value) => {
        if(value==='3'){
            Swal.fire({
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: t('global.yes'),
                cancelButtonText: t('global.no'),
                icon: 'warning',
                text: t('inscriptions.cancelSecure')
            }).then((newresult) => {
                if (newresult.isConfirmed) {
                    dispatch(editInscription(inscription, value, 'status', 'club'))
                }
            })
        }else{
            dispatch(editInscription(inscription, value, 'status', 'club'))
        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString)
        return date.toLocaleDateString('es-ES')
    }

    const columnsInscriptions = [
        {
            name: t('inscriptions.client'),
            cell: inscription =>
                <div
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.client?.firstname} {inscription?.client?.lastname}
                </div>,
            selector: (inscription) => inscription.firstname+' '+inscription.lastname,
            sortable: true,
        },{
            name: <>{t('groups.activity')} / {t('groups.category')}</>,
            cell: inscription =>
                <div
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.activity?.title} / {inscription?.category?.title}
                </div>,
            selector: (inscription) => inscription?.activity?.title+' '+inscription?.category?.title,
            sortable: true,
        },{
            name: <>{t('inscriptions.group')} / {t('inscriptions.horary')}</>,
            cell: inscription =>
                <>{inscription?.group?.title} / {inscription?.horary?.name}</>,
            selector: (inscription) => inscription?.group?.title+' '+inscription?.horary?.name,
            sortable: true,
        },{
            name: t('inscriptions.status'),
            center: 'true',
            cell: inscription => inscription.translatedStatus,
            selector: (inscription) => inscription.translatedStatus,
            sortable: true,
        },{
            name: t('inscriptions.paymentStatus'),
            center: 'true',
            cell: inscription =>
                !inscription.paymentStatus && inscription.paymentStatus !== 0
                    ?
                        <></>
                    :
                        <span className={`p-2 text-white ${inscription.paymentStatus === 0 ? 'bg-success' : inscription.paymentStatus === 1 ? 'bg-warning' : 'bg-danger'}`}>
                            {
                                inscription.paymentStatus === 0
                                    ?
                                        <i className='fas fa-check'/>
                                    :
                                        inscription.paymentStatus === 1
                                            ?
                                                <i className='fas fa-clock'/>
                                            :
                                                <i className='fas fa-x'/>
                            }
                        </span>
            ,
            selector: (inscription) => inscription.paymentStatus === 0 ? 'success' : inscription.paymentStatus === 1 ? 'warning' : 'danger',
            sortable: true,
        },{
            name: t('inscriptions.actions'),
            center: 'true',
            width:'120px',
            cell: inscription =>
                <div className='action-icons'>
                    <div
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('view')
                            setShow(true)
                        }}>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.seeinscription')}</Tooltip>}
                        >
                            <i className="fas fa-eye"></i>
                        </OverlayTrigger>
                    </div>
                    <div
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('edit')
                            setShow(true)
                        }}>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.editinscription')}</Tooltip>}
                        >
                            <i className="fas fa-pen-to-square"></i>
                        </OverlayTrigger>
                    </div>
                    {inscription?.status === "0" || inscription?.status === "4" ?
                        <>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.approveinscription')}</Tooltip>}
                            >
                                <i className="fas fa-check" onClick={() => handleSelectChange(inscription?._id, "1")}></i>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        </>
                    :
                        inscription?.status !== "3" ?
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        :
                            ''
                    }
                </div>,
            selector: (inscription) => inscription?.group?.title,
            sortable: false,
        }
	]
    const ExpandedRow = ({ data }) => {
        return (
            <Container className='p-3'>
                <Row>
                    <Col xs={12} lg={6}>
                        <div className='client-data-row'>
                            <span className='client-data-label'>{t('users.birthdate')}</span>
                            <span className='client-data-value'>{formatDate(data?.client?.birthdate)}</span>
                        </div>
                        <div className='client-data-row'>
                            <span className='client-data-label'>{t('users.phone')}</span>
                            <span className='client-data-value'>{data?.client?.phone}</span>
                        </div>
                        <div className='client-data-row'>
                            <span className='client-data-label'>{t('users.emergencyphone')}</span>
                            <span className='client-data-value'>{data?.client?.emergencyPhone}</span>
                        </div>
                        <div className='client-data-row'>
                            <span className='client-data-label'>{t('users.email')}</span>
                            <span className='client-data-value'>{data?.clientEmail}</span>
                        </div>
                        {data?.client?.identityDocuments?.length > 0
                        ?
                            <div className='flex-column' style={{padding: '10px 0', borderBottom: '1px solid var(--border-subtle)'}}>
                                {data?.client?.identityDocuments?.map((doc, index) => (
                                    <div key={index} className='client-data-row'>
                                        <span className='client-data-label'>{doc.documentType}</span>
                                        <span className='client-data-value'>{doc.documentNumber}</span>
                                    </div>
                                ))}
                            </div>
                         :
                            <></>
                        }
                         {data?.client?.addresses?.length > 0
                        ?
                            <div className='flex-column' style={{padding: '10px 0', borderBottom: '1px solid var(--border-subtle)'}}>
                                {data?.client?.addresses?.map((address, index) => (
                                    <div key={index} className='client-data-row' style={{flexDirection: 'column', alignItems: 'flex-start', gap: 4}}>
                                        <span className='client-data-label'>{t('menus.config.address')}</span>
                                        <div className='client-data-value' style={{textAlign: 'left'}}>
                                            {address.address}<br/>
                                            {address.town} ({address.province})<br/>
                                            {address.postalCode}
                                        </div>
                                    </div>
                                ))}
                            </div>
                         :
                            <></>
                        }
                    </Col>
                    <Col xs={12} lg={6}>
                        {data?.tutor1Name
                            ?
                                <>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor1Name')}</span>
                                        <span className='client-data-value'>{data?.tutor1Name}</span>
                                    </div>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor1Phone')}</span>
                                        <span className='client-data-value'>{data?.tutor1Phone}</span>
                                    </div>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor1Email')}</span>
                                        <span className='client-data-value'>{data?.tutor1Email}</span>
                                    </div>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor2Name')}</span>
                                        <span className='client-data-value'>{data?.tutor2Name}</span>
                                    </div>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor2Phone')}</span>
                                        <span className='client-data-value'>{data?.tutor2Phone}</span>
                                    </div>
                                    <div className='client-data-row'>
                                        <span className='client-data-label'>{t('users.tutor2Email')}</span>
                                        <span className='client-data-value'>{data?.tutor2Email}</span>
                                    </div>
                                </>
                            :
                                <></>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
    return (
        <>
            <Container className='cuerpo'>
                <ClubBreadCrumbs usertype={usertype} club={club} />
                <Row>
                    <Col className='d-flex align-items-center'>
                        <h1 className='ms-2 my-0'>{t('menus.activities.inscriptions')}</h1>
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col>
                        <ActivitiesSubMenu usertype={usertype} active="inscriptions"/>
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col>
                        <Card>
                            {loadinginscriptions
                            ?
                                <Loader/>
                            :
                                <Card.Body>
                                    <div className="my-3">
                                        <Row>
                                            <Col>
                                                {inscriptions?.length > 0 ?
                                                    <CustomDataTable
                                                        columns={columnsInscriptions}
                                                        data={translatedInscriptions}
                                                        exportable={true}
                                                        printable={true}
                                                        expandedData={ExpandedRow}
                                                    />
                                                :
                                                    <div className='contenedor-vacio text-center'>
                                                        <i className="fas fa-clipboard-list" style={{fontSize: 32, color: 'var(--text-tertiary)', marginBottom: 16}}></i>
                                                        <h4>{t('inscriptions.thereisnotinscriptions')}</h4>
                                                        <p>{t('inscriptions.thereisnotinscriptionsphrase')}</p>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </Card.Body>
                            }
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2 style={{fontSize: 20, margin: 0}}>{t('inscriptions.datainscription')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='cuerpo px-5 py-4'>
                    <InscriptionSummary
                        usertype={usertype}
                        typeform={typeform}
                        inscriptionselected={inscriptionselected}
                        closeModal={handleClose}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}